import { StyleSheet } from "@react-pdf/renderer";
import { blue } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },
  slideContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    padding: "20px",
    marginVertical: "auto",
  },
  columnLeft: {
    width: "50%",
    padding: "20px",
  },
  columnRight: {
    width: "50%",
    padding: "20px",
  },
  subTitle: {
    fontSize: "14px",
    fontStyle: "bold",
  },
  paragraph: {
    fontSize: "13px",
    marginVertical: "15px",
    textAlign: "justify",
    lineHeight: "1.4px",
  },
  link: { fontSize: "13px", lineHeight: "1.4px" },
});
